import { render, staticRenderFns } from "./OlvidePasswordView.vue?vue&type=template&id=164714a0"
import script from "./OlvidePasswordView.vue?vue&type=script&lang=js"
export * from "./OlvidePasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports